<template>
  <material-card
    :title="editDialogTitle"
    :icon="editDialogIcon"
    :color="formColor"
  >
    <v-card-text>
      <v-dialog
        v-model="showChequeRequisitionForm"
        scrollable
        max-width="800"
        persistent
      >
        <cheque-requisition-form
          :option="option"
          v-on:save="showChequeRequisitionForm = false"
          v-on:cancel="
            option.IncludeChequeRequisition = false;
            showChequeRequisitionForm = false;
          "
          :dialog="showChequeRequisitionForm"
        ></cheque-requisition-form>
      </v-dialog>
      <v-form ref="form" v-model="valid" v-if="reportParameters">
        <v-row>
          <v-col cols="auto">
            <v-autocomplete
              v-model="selectedPlan"
              :items="plans"
              :label="$t('globals.plans')"
              item-value="Id"
              return-object
              :rules="[$rules.required]"
              class="required"
            >
              <template v-slot:selection="data">
                {{
                    translate2(data.item, 'Name')
                }}
              </template>
              <template v-slot:item="data">
                <v-list-item-content
                  v-text="translate2(data.item, 'Name')
                  "
                ></v-list-item-content>
              </template>
            </v-autocomplete>
            <!-- <trans-select3
              v-model="selectedPlan"
              :items="plans"
              :label="$t('globals.plans')"
              item-value="Id"
              :rules="[$rules.required]"
              class="required"
            /> -->
          </v-col>
          <v-col cols="auto">
            <v-autocomplete
              v-model="selectedReport"
              :items="reportTypes"
              :label="$t('components.getreports.select_report')"
              :rules="[$rules.required]"
              class="required"
              :slots="true"
              :filter="filterFunc"
            >
              <template v-slot:selection="data">
                {{ $t("components.getreports." + data.item) }}
              </template>
              <template v-slot:item="data">
                <v-list-item-content
                  v-text="$t('components.getreports.' + data.item)"
                ></v-list-item-content>
              </template>
            </v-autocomplete>
          </v-col>
          <v-col
            cols="auto"
            xs12
            sm6
            md4
            lg4
            v-if="selectedReport === 'Premiums'"
          >
            <trans-multi-select2
              v-model="selected.InsuranceCarriers"
              :items="insuranceCarriers"
              :label="$t('globals.insurance_carrier')"
              :rules="[$rules.required]"
              field="Name"
              itemValue="Id"
              :displayFunc="
                (item, str) =>
                  `${translate2(item.InsuranceCarrier, 'Name')} (${
                    item.PolicyIdentity.Current.Number
                  })`
              "
              :canSelectAll="true"
              class="required"
            ></trans-multi-select2>
          </v-col>
          <v-col
            cols="auto"
            xs12
            sm6
            md4
            lg4
            v-if="selectedReport === 'Billing'"
          >
            <trans-multi-select2
              v-model="selected.Employers"
              :items="employers"
              :label="$t('globals.employers')"
              :rules="[$rules.required]"
              field="Name"
              itemValue="Id"
              :canSelectAll="true"
              class="required"
              transPropertyName="Current"
            ></trans-multi-select2>
          </v-col>
          <v-col
            cols="xs12 sm6"
            v-if="selectedReport === 'Billing' && stores.length > 0"
          >
            <trans-multi-select2
              v-model="selected.Stores"
              :items="stores"
              :label="$t('globals.stores')"
              field="Name"
              itemValue="Id"
              :canSelectAll="true"
              transPropertyName="Current"
            ></trans-multi-select2>
          </v-col>
          <v-col
            cols="auto"
            xs12
            sm6
            md4
            lg4
            v-if="selectedReport === 'Remittances'"
          >
            <trans-multi-select2
              v-model="selected.TrustFunds"
              :items="trustFunds"
              :label="$t('components.getreports.trust_fund')"
              field="Name"
              itemValue="Id"
              :canSelectAll="true"
            ></trans-multi-select2>
          </v-col>
          <v-col
            cols="auto"
            xs12
            sm6
            md4
            lg4
            v-if="coverageGroupItems && coverageGroupItems.length > 0"
          >
            <trans-multi-select2
              v-model="selected.CoverageGroups"
              :items="coverageGroupItems"
              :label="$t('components.getreports.coverage_groups')"
              field="Name"
              itemValue="Name"
              :canSelectAll="true"
            ></trans-multi-select2>
          </v-col>
          <v-col cols="auto" class="align-self-center">
            <v-checkbox
              v-model="reportParameters.IncludeTotal"
              :label="$t('components.getreports.include_plan_summary')"
              v-if="showPlanSummary()"
            ></v-checkbox>
          </v-col>
        </v-row>
        <v-row>
          <table class="report-options">
            <tr v-for="(item, i) in reportParameters.Options" :key="i">
              <td class="align-self-center">
                <h2>{{ item.Name }}</h2>
              </td>
              <td
                cols="auto"
                class="align-self-center"
                v-if="selectedReport !== 'Billing' || !item.EmployerHasStores"
              >
                <v-checkbox
                  v-model="item.IncludeMemberDetails"
                  :label="$t('components.getreports.include_member_details')"
                ></v-checkbox>
              </td>
              <td
                cols="auto"
                class="align-self-center"
                v-if="selectedReport === 'Billing' && !item.EmployerHasStores"
              >
                <v-checkbox
                  v-model="item.IncludeGroupSummary"
                  :label="$t('components.getreports.include_group_summary')"
                ></v-checkbox>
              </td>
              <td
                cols="auto"
                class="align-self-center"
                v-if="selectedReport === 'Premiums'"
              >
                <v-checkbox
                  v-model="item.IncludeGroupSummary"
                  :label="
                    $t('components.getreports.include_coverage_summary_group')
                  "
                ></v-checkbox>
              </td>
              <td
                cols="auto"
                class="align-self-center"
                v-if="
                  item.InsuranceCarrierId &&
                    item.InsuranceCarrierId !==
                      '00000000-0000-0000-0000-000000000000'
                "
              >
                <v-checkbox
                  v-model="item.IncludeTotal"
                  :label="$t('components.getreports.include_carrier_summary')"
                ></v-checkbox>
              </td>
              <!-- <td
                cols="auto"
                class="align-self-center"
                v-if="item.EmployerId && !item.EmployerHasStores"
              >
                <v-checkbox
                  v-model="item.IncludeTotal"
                  :label="$t('components.getreports.include_employer_summary')"
                ></v-checkbox>
              </td> -->
              <td
                cols="auto"
                class="align-self-center"
                v-if="
                  item.EmployerId &&
                    item.EmployerId !==
                      '00000000-0000-0000-0000-000000000000' &&
                    item.EmployerHasStores
                "
              >
                <v-checkbox
                  v-model="item.IncludeTotal"
                  :label="$t('components.getreports.include_stores_summary')"
                ></v-checkbox>
              </td>
              <td
                cols="auto"
                class="align-self-center"
                v-if="selectedReport === 'Remittances'"
              >
                <v-checkbox
                  v-model="item.IncludeGroupSummary"
                  :label="
                    $t('components.getreports.include_coverage_summary_group')
                  "
                ></v-checkbox>
              </td>
              <td
                cols="auto"
                class="align-self-center"
                v-if="selectedReport === 'Remittances'"
              >
                <v-checkbox
                  v-model="item.IncludeTotal"
                  :label="$t('components.getreports.include_trustfund_total')"
                ></v-checkbox>
              </td>
              <td
                cols="auto"
                class="align-self-center"
                v-if="selectedReport === 'Premiums'"
              >
                <v-checkbox
                  v-model="item.IncludeChequeRequisition"
                  :label="
                    $t(
                      'components.getreports.include_chequepayment_requisition_form'
                    )
                  "
                  @change="chequeChanged(item)"
                ></v-checkbox>
              </td>
            </tr>
          </table>
        </v-row>
        <v-row>
          <v-checkbox
            v-model="canHaveReports"
            :label="$t('components.getreports.can_have_reports')"
          ></v-checkbox>
        </v-row>
      </v-form>
    </v-card-text>
    <v-card-actions>
      <v-btn color="primary" @click="close">
        {{ $t("globals.close") }}
      </v-btn>
      <v-btn :disabled="!reportSelectionValid" color="primary" @click="save">
        {{ $t("globals.save") }}
      </v-btn>
    </v-card-actions>
    <error-handler :error="error"></error-handler>
    <v-snackbar
      v-model="mailAlert.show"
      :bottom="true"
      :color="mailAlert.type"
      :multi-line="true"
      :timeout="6000"
    >
      {{ mailAlert.text }}
      <v-btn dark text @click="mailAlert.show = false">X</v-btn>
    </v-snackbar>
  </material-card>
</template>

<script>
import ChequeRequisitionForm from "../components/ChequeRequisitionForm";
import { mapGetters, mapActions } from "vuex";
import ErrorHandler from "../components/ErrorHandler";
import TransMultiSelect2 from "../components/TransMultiSelect2";
import { translate2 } from "../trans2";
import { sortAlphanum } from "../alphanumericSort";

export default {
  name: "users-reports-configuration-form",
  components: {
    ChequeRequisitionForm,
    ErrorHandler,
    TransMultiSelect2,
  },
  props: [
    "plans",
    "reportsConfiguration",
    "existingReportsTypes",
    "user",
    "roles",
  ],
  computed: {
    ...mapGetters("common", {
      settings: "settings",
      brokerId: "brokerId",
    }),
    ...mapGetters("common", ["language"]),
    editDialogTitle() {
      if (this.report && this.report.id) {
        return (
          "Edit report configuration for plan " +
          translate2(this.report.Plan.Translations, "Name")
        );
      } else {
        return "New report configuration";
      }
    },
    editDialogIcon() {
      if (this.report && this.report.id) {
        return "edit";
      } else {
        return "add";
      }
    },
    formColor() {
      return this.report && this.report.id ? this.$vuetify.theme.themes.light.primary : this.$vuetify.theme.themes.light.success;
    },
  },
  data() {
    return {
      selectedPlan: null,
      planParameters: null,
      reportTypes: [], //Premiums, Remittances, Billing
      autoloading: false,
      // broker: null,
      error: null,
      numPages: 0,
      option: null,
      canHaveReports: false,
      showChequeRequisitionForm: false,
      reportParameters: null,
      loading: false,
      reportSelectionValid: false,
      insuranceCarriers: [],
      employers: [],
      selected: {
        Employers: [],
        TrustFunds: [],
        Stores: [],
        InsuranceCarriers: [],
        CoverageGroups: [],
      },
      stores: [],
      trustFunds: [],
      coverageGroupItems: [],
      coverageGroups: [],
      mailAlert: {
        show: false,
      },
      selectedReport: null,
      valid: true,
      userInfo: null,
      dataLoading: false,
    };
  },
  watch: {
    reportsConfiguration: {
      async handler(v) {
        if (v === null || v === undefined) {
          return;
        }
        this.dataLoading = true;
        this.reportParameters = v.ReportParameters;
        this.canHaveReports = v.CanHaveReports;

        this.selected = {
          InsuranceCarriers: [],
          Trustfunds: [],
          Employers: [],
          Stores: [],
          CoverageGroups: [],
        };
        if (v && v.PlanId) {
          this.selectedPlan = v.Plan;

          this.planParameters = await this.getPlanParameters(v.PlanId);
          await this.loadData();
          this.selectedReport = v.ReportParameters.ReportType;
          let selectedStores = [];
          let selectedInsuranceCarriers = [];
          // let index = -1;
          console.log(v);
          for (const option of v.ReportParameters.Options) {
            console.log(option);
            if (
              option.InsuranceCarrierId &&
              option.InsuranceCarrierId !==
                "00000000-0000-0000-0000-000000000000"
            ) {
              // index = this.insuranceCarriers.indexOf(this.insuranceCarriers.filter(o=>o.Id === option.InsuranceCarrierId)[0]);
              // this.selectedInsuranceCarriers.push(this.insuranceCarriers[index])
              selectedInsuranceCarriers.push(
                this.insuranceCarriers.filter(
                  (o) => o.Id === option.InsuranceCarrierId
                )[0]
              );
            } else if (
              option.TrustfundId &&
              option.TrustfundId !== "00000000-0000-0000-0000-000000000000"
            ) {
              this.selected.Trustfunds.push(
                this.trustFunds.filter((o) => o.Id === option.TrustfundId)[0]
              );
            } else if (
              option.EmployerId &&
              option.EmployerId !== "00000000-0000-0000-0000-000000000000"
            ) {
              console.log(this.employers, option.EmployerId);
              this.selected.Employers.push(
                this.employers.filter((o) => o.Id === option.EmployerId)[0]
              );
            } else if (
              option.StoreId &&
              option.StoreId !== "00000000-0000-0000-0000-000000000000"
            ) {
              selectedStores.push(option.StoreId);
            }
          }

          // if (this.selected.Employers && this.selected.Employers.length > 0) {
          //   if (this.planParameters.ReportsPerStore) {
          //     this.selected.Stores = [];
          //     this.stores = [];
          //   }
          //   await this.mapEmployersToPayloadOptions(this.selected.Employers);
          //   // await this.getCoverageGroups();
          // } else {
          //   this.coverageGroupItems = [];
          //   this.stores = [];
          //   await this.mapEmployersToPayloadOptions(this.selected.Employers);
          // }
          for (let i of this.selected.Employers) {
            let stores = (await this.getStoresWithFilter({
              plan: this.selectedPlan.Id,
              filter: "$filter=EmployerId eq " + i.Id,
            })).data.value.filter(
              (o) => this.user.Stores.filter((s) => s.Id === o.Id).length > 0
            );
            var employerHasStores =
              this.planParameters.ReportsPerStore && stores
                ? stores.length > 0
                : false;
            if (employerHasStores) {
              //var stores = [{ Id: 0, Name: "All Stores" }].concat(empl.Stores);
              this.stores = this.stores.concat(stores);
            }
          }

          for (const storeId of selectedStores) {
            this.selected.Stores.push(
              this.stores.filter((o) => o.Id === storeId)[0]
            );
          }

          this.selected.InsuranceCarriers = selectedInsuranceCarriers;

          console.log(
            this.reportParameters.Options,
            selectedInsuranceCarriers.length,
            this.selected.InsuranceCarriers.length
          );
        } else {
          this.selectedPlan = null;
          this.selectedReport = null;
          this.insuranceCarriers = [];
          this.employers = [];
          this.trustFunds = [];
          this.stores = [];
          this.reportTypes = [];
        }
        this.$nextTick(() => {
          this.dataLoading = false;
          this.reportSelectionValid = this.checkForValidReportSelection();
        });
      },
    },
    selectedPlan: {
      async handler(v) {
        if (!this.dataLoading) {
          if (v) {
            this.planParameters = await this.getPlanParameters(v.Id);
            this.reportTypes = [];
            this.selectedReport = null;
            await this.loadData();
            console.log("mounted: ", this.reportTypes, this.selectedReport);

            // if (this.reportTypes.length > 0) {
            //   this.selectedReport = this.reportTypes[0];
            // } else {
            //   this.selectedReport = null;
            // }

            // this.selectAll();

            console.log(this.selectedReport);
          }
        }
      },
      immediate: true,
    },
    selectedReport: {
      async handler(v) {
        if (!this.dataLoading) {
          if (this.reportParameters) {
            this.reportParameters.Options = [];
          }
          this.selected.InsuranceCarriers = [];
          this.selected.Employers = [];
          this.selected.TrustFunds = [];
          if (v) {
            console.log("selectedReport: ", v);

            // this.selectAll();
          } else {
            this.reportSelectionValid = false;
          }
        }
      },
      deep: true,
    },
    "selected.Employers": {
      async handler(v) {
        console.log("selected employers: ", JSON.stringify(v));
        if (!this.dataLoading) {
          this.autoloading = true;
          if (v && v.length > 0) {
            if (this.planParameters.ReportsPerStore) {
              this.selected.Stores = [];
              this.stores = [];
              //   let stores = (await this.getStoresWithFilter({
              //       plan: this.selectedPlan.Id,
              //       filter: "$filter=EmployerId eq " + v[0].Id,
              //     })).data.value;
              //   if (stores.length > 0) {
              //     this.stores = stores;
              //     this.selected.Stores = this.stores;
              //   } else {
              //     this.stores = [];
              //   }
            }
            console.log("Employers----------");
            await this.mapEmployersToPayloadOptions(v);
            // await this.getCoverageGroups();
          } else {
            this.coverageGroupItems = [];
            this.stores = [];
            console.log("gotcha!");
            await this.mapEmployersToPayloadOptions(v);
          }
          this.autoloading = false;
        } else {
          console.log("data loading");
        }
      },
      deep: true,
    },
    "selected.Stores": {
      async handler(v, old) {
        console.log("selected stores: ", JSON.stringify(v));
        if (!this.dataLoading) {
          this.autoloading = true;
          await this.mapStoresToPayloadOptions(v, old);
          this.autoloading = false;
        }
      },
      deep: true,
    },
    "selected.InsuranceCarriers": {
      async handler(v) {
        console.log("selected i c", JSON.stringify(v));
        console.log(JSON.stringify(this.insuranceCarriers));
        if (!this.dataLoading) {
          this.autoloading = true;
          if (v && v.length > 0) {
            const d = new Date();
            this.reportParameters.Options = v.map((i) => {
              return {
                DateOfRequest: this.toUtcString(d),
                Name: translate2(i.InsuranceCarrier, "Name"),
                InsuranceCarrierName: translate2(i.InsuranceCarrier, "Name"),
                InsuranceCarrierId: i.Id,
                User: this.user.Email,
                IncludeMemberDetails: true,
                IncludeGroupSummary: true,
                IncludeTotal: true,
                IncludeChequeRequisition: true,
              };
            });
            console.log("33333333333333333");
            // await this.getCoverageGroups();
          } else {
            this.coverageGroupItems = [];
            if (this.reportParameters) {
              this.reportParameters.Options = [];
            }
          }
          this.autoloading = false;
        }
      },
      deep: true,
    },
    "selected.TrustFunds": {
      async handler(v) {
        if (!this.dataLoading) {
          this.autoloading = true;
          if (v) {
            console.log("selected t f", JSON.stringify(v));
            if (this.reportParameters) {
              this.reportParameters.Options = v.map((i) => {
                return {
                  Name: translate2(i, "Name"),
                  TrustfundId: i.Id,
                  User: this.user.Email,
                  IncludeMemberDetails: true,
                  IncludeGroupSummary: true,
                  IncludeTotal: true,
                };
              });
            }
            // await this.getCoverageGroups();
          } else {
            this.coverageGroupItems = [];
            if (this.reportParameters) {
              this.reportParameters.Options = [];
            }
          }
          this.autoloading = false;
        }
      },
      deep: true,
    },
    "selected.CoverageGroups": {
      handler(v) {
        //console.log("selected.coverageGroups");
        //console.log(v);
        this.reportSelectionValid = this.checkForValidReportSelection();
      },
      deep: true,
    },
    coverageGroups: {
      handler(v) {
        console.log("coverageGroups");
        console.log(v);
        this.coverageGroupItems = v.map((cg) => {
          return { Name: cg };
        });
        if (this.coverageGroupItems.length > 0) {
          // this.selected.CoverageGroups = this.coverageGroupItems[0];
        }
      },
      deep: true,
    },
    // selected: {
    //   handler(v) {
    //     //console.log("selected changed");
    //     //console.log(v);
    //   },
    //   deep: true,
    // },
    "reportParameters.Options": {
      handler(v) {
        console.log("payload: ", JSON.stringify(v));
        this.reportSelectionValid = this.checkForValidReportSelection();
      },
      deep: false,
    },
  },
  async mounted() {
    try {
      // this.broker = (await this.getOrganizationById({
      //   id: this.brokerId,
      // })).data;
      this.trustFunds = [];
      this.insuranceCarriers = [];
      this.employers = [];
      this.coverageGroups = [];
      console.log(this.plans);
    } catch (error) {
      this.error = error;
    }
  },
  methods: {
    ...mapActions("data", ["fetchFile"]),
    ...mapActions("plansMembers", [
      "getInsuranceCarriers",
      "getTrustFunds",
      "getEmployers",
      "getContacts",
      "getStoresWithFilter",
      // "getOrganizationById",
      "getPlanParameters",
    ]),
    ...mapActions("transactions", [
      "getInsuranceCarrierCoverageGroups",
      "getTrustfundCoverageGroups",
      "getPlanCoverageGroups",
    ]),
    translate2(item, field) {
      return translate2(item, field);
    },
    filterFunc(item, search) {
      console.log(item);
      return (
        this.$t("components.getreports." + item)
          .toLowerCase()
          .indexOf(search.toLowerCase()) > -1
      );
    },
    async loadData() {
      if (
        this.planParameters.HasPremiums &&
        (this.roles.indexOf("Broker Plan Admin") > -1 ||
          this.roles.indexOf("Broker Plan Manager") > -1 ||
          this.roles.indexOf("Employer Premiums Viewer") > -1) &&
        (this.existingReportsTypes[this.selectedPlan.Id] === null ||
          this.existingReportsTypes[this.selectedPlan.Id] === undefined ||
          this.reportParameters.ReportType === "Premiums" ||
          (this.existingReportsTypes[this.selectedPlan.Id] &&
            this.existingReportsTypes[this.selectedPlan.Id].indexOf(
              "Premiums"
            ) === -1))
      ) {
        try {
          this.insuranceCarriers = (await this.getInsuranceCarriers(
            this.selectedPlan.Id
          )).data.value;
          this.reportTypes.push("Premiums");
          console.log(this.insuranceCarriers);
        } catch (error) {
          error.messageParams = ["Premiums"];
          this.error = error;
        }
      }
      if (
        this.planParameters.HasBilling &&
        (this.roles.indexOf("Broker Plan Admin") > -1 ||
          this.roles.indexOf("Broker Plan Manager") > -1 ||
          this.roles.indexOf("Employer Plan Admin") ||
          this.roles.indexOf("Employer Members Viewer") ||
          this.roles.indexOf("Employer Billing Viewer") > -1) &&
        (this.existingReportsTypes[this.selectedPlan.Id] === null ||
          this.existingReportsTypes[this.selectedPlan.Id] === undefined ||
          this.reportParameters.ReportType === "Billing" ||
          (this.existingReportsTypes[this.selectedPlan.Id] &&
            this.existingReportsTypes[this.selectedPlan.Id].indexOf(
              "Billing"
            ) === -1))
      ) {
        try {
          this.employers = (await this.getEmployers({
            plan: this.selectedPlan.Id,
          })).data.value.sort((a, b) => {
              const translatedA =  a.Current.Translations.filter(
                  (o) => o.LanguageCode === this.language.language
                )[0].Name;
              const translatedB = b.Current.Translations.filter(
                  (o) => o.LanguageCode === this.language.language
                )[0].Name;
                console.log(translatedA, translatedB);
              return sortAlphanum(translatedA, translatedB);
            });
          if (
            this.roles.indexOf("Employer Plan Admin") > -1 ||
            this.roles.indexOf("Employer Members Viewer") > -1 ||
            this.roles.indexOf("Employer Billing Viewer") > -1
          ) {
            let employers = this.employers.filter(
              (o) => this.user.Employers.filter((e) => e.Id === o.Id).length > 0
            );
            console.log(employers, this.employers, this.user.Employers);
          }
          this.reportTypes.push("Billing");
        } catch (error) {
          error.messageParams = ["Billing"];
          this.error = error;
        }
      }
      if (
        this.planParameters.HasRemittances &&
        (this.roles.indexOf("Broker Plan Admin") > -1 ||
          this.roles.indexOf("Broker Plan Manager") > -1) &&
        (this.existingReportsTypes[this.selectedPlan.Id] === null ||
          this.existingReportsTypes[this.selectedPlan.Id] === undefined ||
          this.reportParameters.ReportType === "Remittances" ||
          (this.existingReportsTypes[this.selectedPlan.Id] &&
            this.existingReportsTypes[this.selectedPlan.Id].indexOf(
              "Remittances"
            ) === -1))
      ) {
        try {
          this.trustFunds = [
            (await this.getTrustFunds(this.selectedPlan.Id)).data,
          ];
          this.reportTypes.push("Remittances");
        } catch (error) {
          error.messageParams = ["Remittances"];
          this.error = error;
        }
      }
    },
    selectAll() {
      console.log("select all: ", this.selectedReport);
      if (this.selectedReport === "Premiums") {
        if (this.insuranceCarriers.length > 0) {
          this.$nextTick(() => {
            this.selected.InsuranceCarriers = [this.insuranceCarriers[0]];
          });
        }
      } else if (this.selectedReport === "Billing") {
        if (this.employers.length > 0) {
          this.$nextTick(() => {
            this.selected.Employers = [this.employers[0]];
          });
        }
      } else if (this.selectedReport === "Remittances") {
        if (this.trustFunds.length > 0) {
          this.$nextTick(() => {
            this.selected.TrustFunds = [this.trustFunds[0]];
          });
        }
      }
    },
    showPlanSummary() {
      //console.log(this.selectedReport, this.employers);
      switch (this.selectedReport) {
        case "Premiums":
          return this.insuranceCarriers && this.insuranceCarriers.length > 1;
        case "Billing":
          return this.employers && this.employers.length > 0;
        case "Remittances":
          return this.trustFunds && this.trustFunds.length > 1;
      }
    },
    toUtcString(date) {
      const utcString =
        date.getFullYear() +
        "-" +
        this.getMonth(date) +
        "-" +
        this.getDate(date) +
        "T00:00:00.0Z";
      //console.log(utcString);
      return utcString;
    },
    getMonth(date) {
      let month = (date.getMonth() + 1).toString();
      if (month.length === 1) {
        month = "0" + month;
      }
      return month;
    },
    getDate(date) {
      let d = date.getDate().toString();
      if (d.length === 1) {
        d = "0" + d;
      }
      return d;
    },
    async mapEmployersToPayloadOptions(v) {
      if (this.reportParameters) {
        this.reportParameters.Options = [];
      }
      //console.log(JSON.stringify(v), JSON.stringify(this.payload.Options));
      console.log("mepo: ", JSON.stringify(v));
      for (const i of v) {
        //var empl = this.employers.filter(e => e.Id == i.Id)[0];
        console.log(JSON.stringify(i));

        let stores = await this.getStoresWithFilter({
          plan: this.selectedPlan.Id,
          filter: "$filter=EmployerId eq " + i.Id,
        });
        if (
          this.roles.indexOf("Employer Plan Admin") > -1 ||
          this.roles.indexOf("Employer Members Viewer") > -1 ||
          this.roles.indexOf("Employer Billing Viewer") > -1
        ) {
          stores = stores.data.value.filter(
            (o) => this.user.Stores.filter((s) => s.Id === o.Id).length > 0
          );
        }
        var employerHasStores =
          this.planParameters.ReportsPerStore && stores
            ? stores.length > 0
            : false;
        if (employerHasStores) {
          //var stores = [{ Id: 0, Name: "All Stores" }].concat(empl.Stores);
          this.stores = this.stores.concat(stores);
        }
        if (
          this.reportParameters.Options.filter((o) => o.EmployerId === i.Id)
            .length === 0
        ) {
          this.reportParameters.Options.push({
            Name: translate2(i, "Name"),
            EmployerId: i.Id,
            User: this.user.Email,
            EmployerHasStores: employerHasStores,
          });
          if (employerHasStores) {
            this.reportParameters.Options[
              this.reportParameters.Options.length - 1
            ].IncludeTotal = true;
          } else {
            this.reportParameters.Options[
              this.reportParameters.Options.length - 1
            ].IncludeGroupSummary = true;
            this.reportParameters.Options[
              this.reportParameters.Options.length - 1
            ].IncludeMemberDetails = true;
          }
        }
      }
      if (v.length === 0) {
        this.selected.Stores = [];
      }
      //console.log(JSON.stringify(this.payload.Options));
      this.reportSelectionValid = this.checkForValidReportSelection();
    },
    mapStoresToPayloadOptions(v, old) {
      //console.log(JSON.stringify(v), JSON.stringify(old), old !== v);
      if (v && v.length > 0) {
        const options = v.map((i) => {
          console.log(i);
          //var empl = this.stores.filter(e => e.Id == i.Id)[0];
          return {
            Name: translate2(i, "Name"),
            StoreId: i.Id,
            User: this.user.Email,
            IncludeMemberDetails: true,
            IncludeGroupSummary: true,
          };
        });
        console.log("regotcha!");
        this.mapEmployersToPayloadOptions(this.selected.Employers);
        // this.payload.Options = options.concat(this.payload.Options);
        this.reportParameters.Options = this.reportParameters.Options.concat(
          options
        );
        // this.payload.Options.splice(1,0,options);
        this.reportSelectionValid = this.checkForValidReportSelection();
      } else {
        console.log("STORES", old, v);
        if (old.length > 0 && v.length === 0) {
          console.log("wtf??");
          this.mapEmployersToPayloadOptions(this.selected.Employers);
        }
      }
    },
    chequeChanged(item) {
      this.option = item;
      // this.option.AdditionalNotes = {};
      this.showChequeRequisitionForm = item.IncludeChequeRequisition;
      //console.log(this.option);
    },
    reset() {
      console.log("r e s e t ! ! !", this.reportTypes, this.selectedReport);

      this.selectedReport = null;
      this.selected.InsuranceCarriers = [];
      this.selected.TrustFunds = [];
      this.selected.Employers = [];
      this.selected.Stores = [];
      this.includeTotal = false;
      this.$refs.form.resetValidation();
    },
    displayAddress(obj) {
      let res = "";

      if (obj.SuiteNumber) {
        res += obj.SuiteNumber;
      }
      if (obj.StreetNumber) {
        if (res.length > 0) {
          res += ", ";
        }
        res += obj.StreetNumber.toString();
      }
      if (obj.StreetName) {
        if (res.length > 0) {
          res += ", ";
        }
        res += obj.StreetName;
      }
      if (res.length > 0) {
        res += ", ";
      }
      res += obj.City + ", " + obj.Province.Code;
      if (obj.PostalCode) {
        res += " " + obj.PostalCode;
      }
      return res;
    },
    save() {
      this.reportParameters.HasAdminFees = this.planParameters.HasAdminFees;
      this.reportParameters.HasCommissions = this.planParameters.HasCommissions;
      this.reportParameters.HasContributions = this.planParameters.HasContributions;
      this.reportParameters.HasPaymentTracking = this.planParameters.HasPaymentTracking;
      this.reportParameters.HasRemittances = this.planParameters.HasRemittances;
      this.reportParameters.TracksMembersActivity = this.planParameters.TracksMembersActivity;
      this.reportParameters.CoverageGroups = this.selected.CoverageGroups.map(
        (scg) => {
          console.log(scg);
          return scg.Name;
        }
      );

      this.reportParameters.ReportType = this.selectedReport;
      const payload = {
        Id:
          this.reportsConfiguration !== null &&
          this.reportsConfiguration !== undefined
            ? this.reportsConfiguration.Id
            : undefined,
        PlanId: this.selectedPlan.Id,
        Plan: this.selectedPlan,
        CanHaveReports: this.canHaveReports,
        ReportParameters: this.reportParameters,
      };

      console.log(payload);
      this.$emit("save", payload);
    },
    close() {
      this.$emit("close");
    },
    checkForValidReportSelection() {
      var selections = this.getReportsSelections();
      let valid = selections ? selections.length > 0 : false;
      if (this.coverageGroupItems.length > 0) {
        valid = valid && this.selected.CoverageGroups.length > 0;
      }
      return valid && this.validPayloadOptions();
    },
    validPayloadOptions() {
      let valid = false;
      for (const item of this.reportParameters.Options) {
        switch (this.selectedReport) {
          case "Premiums":
            valid =
              item.IncludeMemberDetails ||
              item.IncludeGroupSummary ||
              item.IncludeTotal;
            break;
          case "Billing":
            if (item.EmployerId) {
              valid = item.EmployerHasStores
                ? item.IncludeTotal
                : item.IncludeMemberDetails || item.IncludeGroupSummary;
            } else if (item.StoreId) {
              valid = item.IncludeMemberDetails || item.IncludeGroupSummary;
            } else {
              valid = false;
            }
            break;
          case "Remittances":
            valid =
              item.IncludeMemberDetails ||
              item.IncludeGroupSummary ||
              item.IncludeTotal;
            break;
        }
        if (valid) {
          break;
        }
      }
      return valid;
    },
    getReportsSelections() {
      //console.log(this.selectedReport);
      switch (this.selectedReport) {
        case "Premiums":
          return this.selected.InsuranceCarriers;
        case "Billing":
          return this.selected.Employers;
        case "Remittances":
          return this.selected.TrustFunds;
      }
    },
    // async getCoverageGroups() {
    //   console.log("get cove groups");
    //   this.selected.CoverageGroups = [];
    //   if (this.selectedReport === "Premiums") {
    //     //console.log(JSON.stringify(this.selected.InsuranceCarriers));
    //     if (
    //       this.selected.InsuranceCarriers &&
    //       this.selected.InsuranceCarriers.length > 0
    //     ) {
    //       console.log("Premiums get CG");
    //       this.coverageGroups = (await this.getInsuranceCarrierCoverageGroups({
    //         planId: this.selectedPlan.Id,
    //         reportId: this.reportId,
    //         insuranceCarrierIds: this.selected.InsuranceCarriers.map(
    //           (o) => o.Id
    //         ),
    //       })).data;
    //     } else {
    //       //console.log("Premiums no CG");
    //       this.coverageGroups = [];
    //     }
    //   } else if (this.selectedReport === "Billing") {
    //     //console.log("Billing get CG");
    //     this.coverageGroups = (await this.getPlanCoverageGroups({
    //       planId: this.selectedPlan.Id,
    //       reportId: this.reportId,
    //     })).data;
    //   } else if (this.selectedReport === "Remittances") {
    //     //console.log("Remittances get CG");
    //     this.coverageGroups = (await this.getTrustfundCoverageGroups({
    //       planId: this.selectedPlan.Id,
    //       reportId: this.reportId,
    //     })).data;
    //   }
    //   //console.log("getCoverageGroups");
    //   //console.log(JSON.stringify(this.coverageGroups));
    //   // if (this.coverageGroups.length > 0) {
    //   //   this.selected.CoverageGroups = [this.coverageGroups[0]];
    //   // }
    // },
  },
};
</script>

<style>
table.report-options td {
  padding: 10px;
}
</style>
